import { render, staticRenderFns } from "./MarkSheetArchive.vue?vue&type=template&id=5c8249ee"
import script from "./MarkSheetArchive.vue?vue&type=script&lang=js"
export * from "./MarkSheetArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports